/**
 * Resolve display preview metadata from a dp_preview API response.
 *
 * @param {Object|null|undefined} proofingPreview
 * @returns {{ url: string, format?: string, filename?: string, variant?: string, page_dimensions?: { width?: number, height?: number, unit?: string } }|null}
 */
export function getDigitalProofPreview(proofingPreview) {
  return proofingPreview?.preview?.url ? proofingPreview.preview : null
}

const PDF_VIEWER_CHROME = 'toolbar=0&navpanes=0&scrollbar=0'
const PDF_POINTS_TO_CSS_PIXELS = 96 / 72

export function isPdfProofPreview(preview) {
  return preview?.format === 'pdf'
}

export function isRasterProofPreview(preview) {
  return preview?.format === 'png' || preview?.format === 'jpeg'
}

export function shouldDisplayPdfAtActualSize(preview, containerWidth) {
  const pageWidth = Number(preview?.page_dimensions?.width)
  const usableContainerWidth = Number(containerWidth)

  if (!Number.isFinite(pageWidth) || pageWidth <= 0) return false
  if (!Number.isFinite(usableContainerWidth) || usableContainerWidth <= 0) return false

  const unit = preview?.page_dimensions?.unit
  const naturalWidth = unit === 'pt' || !unit ? pageWidth * PDF_POINTS_TO_CSS_PIXELS : pageWidth

  return naturalWidth <= usableContainerWidth
}

export function getPdfViewerUrl(url, { preview, containerWidth } = {}) {
  // Native PDF viewers cannot express "fit but never upscale", so choose the closest supported fragment.
  const sizingMode = shouldDisplayPdfAtActualSize(preview, containerWidth) ? 'zoom=100' : 'view=FitH'
  return `${url}#${sizingMode}&${PDF_VIEWER_CHROME}`
}
